/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swap_Row_EquipmentInputs */

const en_us2_swap_row_equipment = /** @type {(inputs: Swap_Row_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipment`)
};

const pt_br2_swap_row_equipment = /** @type {(inputs: Swap_Row_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipamento`)
};

const es_419_swap_row_equipment = /** @type {(inputs: Swap_Row_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipo`)
};

const pt_pt2_swap_row_equipment = /** @type {(inputs: Swap_Row_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipamento`)
};

const fr_fr2_swap_row_equipment = /** @type {(inputs: Swap_Row_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matériel`)
};

const de_de2_swap_row_equipment = /** @type {(inputs: Swap_Row_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausrüstung`)
};

const it_it2_swap_row_equipment = /** @type {(inputs: Swap_Row_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attrezzatura`)
};

/**
* | output |
* | --- |
* | "Equipment" |
*
* @param {Swap_Row_EquipmentInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_row_equipment = /** @type {((inputs?: Swap_Row_EquipmentInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_Row_EquipmentInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_row_equipment(inputs)
	if (locale === "es-419") return es_419_swap_row_equipment(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_row_equipment(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_row_equipment(inputs)
	if (locale === "de-DE") return de_de2_swap_row_equipment(inputs)
	if (locale === "it-IT") return it_it2_swap_row_equipment(inputs)
	return en_us2_swap_row_equipment(inputs)
});
export { swap_row_equipment as "swap.row_equipment" }